/**
 * Orderopatorio
 *
 * The version of the OpenAPI document: 0.15.6-SNAPSHOT
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export const ErrorResponseCode = {
  InvalidRequestParams: 'INVALID_REQUEST_PARAMS',
  NotFound: 'NOT_FOUND',
  NameNotFound: 'NAME_NOT_FOUND',
  Unauthorized: 'UNAUTHORIZED',
  IntegrationError: 'INTEGRATION_ERROR',
  ServerError: 'SERVER_ERROR',
  Forbidden: 'FORBIDDEN',
  TooManyAttempts: 'TOO_MANY_ATTEMPTS',
  AlreadyExists: 'ALREADY_EXISTS',
  SpecificMenuAlreadyExists: 'SPECIFIC_MENU_ALREADY_EXISTS',
  DuplicatedMenu: 'DUPLICATED_MENU',
  BadRequest: 'BAD_REQUEST',
  ClosedForWrite: 'CLOSED_FOR_WRITE',
  ImageNotFound: 'IMAGE_NOT_FOUND',
  ReadImageBytesError: 'READ_IMAGE_BYTES_ERROR',
  StorageUnavailable: 'STORAGE_UNAVAILABLE',
  InvalidUpload: 'INVALID_UPLOAD',
  CompanyNotFound: 'COMPANY_NOT_FOUND',
  MenuNotFound: 'MENU_NOT_FOUND',
  DebtorUser: 'DEBTOR_USER',
  MenuItemNotFound: 'MENU_ITEM_NOT_FOUND',
  MenuItemPriceImmutable: 'MENU_ITEM_PRICE_IMMUTABLE',
  CategoryNotFound: 'CATEGORY_NOT_FOUND',
  ProductNotFound: 'PRODUCT_NOT_FOUND',
  CartNotFound: 'CART_NOT_FOUND',
  ProductAlreadyOrdered: 'PRODUCT_ALREADY_ORDERED',
  PackageRowNotFound: 'PACKAGE_ROW_NOT_FOUND',
  TestimonialNotFound: 'TESTIMONIAL_NOT_FOUND',
  CompanyProvisionerNotFound: 'COMPANY_PROVISIONER_NOT_FOUND',
  SessionNotFound: 'SESSION_NOT_FOUND',
  SessionExpired: 'SESSION_EXPIRED',
  UserNotFound: 'USER_NOT_FOUND',
  OtpNotFound: 'OTP_NOT_FOUND',
  OtpExpired: 'OTP_EXPIRED',
  RefreshExpired: 'REFRESH_EXPIRED',
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ErrorResponseCode =
  typeof ErrorResponseCode[keyof typeof ErrorResponseCode];
